module.exports = __webpack_public_path__ + "img/taobao2you+no1.b30775a4.png";